export const IRIS_GLOBAL_FOOTER_NAVIGATION_GET_REQUEST =
    'IRIS_GLOBAL_FOOTER_NAVIGATION_GET_REQUEST';
export const IRIS_GLOBAL_FOOTER_NAVIGATION_GET_SUCCESS =
    'IRIS_GLOBAL_FOOTER_NAVIGATION_GET_SUCCESS';
